import { render, staticRenderFns } from "./PlanSummary.vue?vue&type=template&id=2e34f7c7"
import script from "./PlanSummary.vue?vue&type=script&lang=js"
export * from "./PlanSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports